import { createRouter, createWebHistory } from 'vue-router'
import unauthorized from '@/middleware/unauthorized'
import authorized from '@/middleware/authorized'
import paid from '@/middleware/paid'
import legalDocumentsEnabled from '@/middleware/legalDocumentsEnabled'
import settings from '@/router/router_settings'
import warehouses from '@/router/router_warehouses'
import patient from '@/router/router_patient'
import services from '@/router/router_services'
import staff from '@/router/router_staff'
import templates from '@/router/router_templates'
import reports from '@/router/router_reports'
import accounting from '@/router/router_accounting'
import cashdesk from '@/router/router_cashdesk'
import cashregister from '@/router/router_cashregister'
import planning from '@/router/router_planning'
import crm from '@/router/router_crm'
import egisz from '@/router/router_egisz'
import marketing from '@/router/router_marketing'
import insurance from '@/router/router_insurance'
import plan_treatments from '@/router/router_plan_treatments'
import laboratories from '@/router/router_laboratories'
import visits from '@/router/router_visits'
import superadmin from '@/router/router_superadmin'
import store from '@/store'

import { reloadOnChunkError } from "@/services/chunkError.helper"

import JwtService from "@/services/jwt.service"

const routes = [

  /// --- Authorization --- ///
  {
    path: '/login', name: 'Login',
    meta: { middleware: [unauthorized], layout: "empty" },
    component: () => import('../components/pages/auth/Login.vue'),
  },
  {
    path: '/admin/login', name: 'AdminLogin',
    meta: { middleware: [unauthorized], layout: "empty" },
    component: () => import('../components/pages/auth/Login.vue'),
  },
  {
    path: '/change-password', name: 'ChangePassword',
    meta: { middleware: [authorized], layout: "empty" },
    component: () => import('../components/pages/auth/ChangePassword.vue'),
  },
  {
    path: '/accept-legal-documents', name: 'AcceptLegalDocuments',
    meta: { middleware: [authorized], layout: "empty" },
    component: () => import('../components/pages/auth/AcceptLegalDocuments.vue'),
  },
  {
    path: '/legal-documents', name: 'LegalDocuments',
    meta: { middleware: [authorized, paid, legalDocumentsEnabled], layout: "default" },
    component: () => import('../components/pages/general/LegalDocuments.vue'),
  },
  {
    path: '/forgot-password', name: 'ForgotPassword',
    meta: { middleware: [unauthorized], layout: "empty" },
    component: () => import('../components/pages/auth/ForgotPassword.vue'),
  },
  {
    path: '/reset-password', name: 'ResetPassword',
    meta: { layout: "empty" },
    component: () => import('../components/pages/auth/ResetPassword.vue'),
  },
  /// --- Calendar --- ///
  { path: '', redirect: '/calendar' },
  {
    path: '/calendar', name: 'Calendar',
    meta: { middleware: [authorized, paid], layout: "default" },
    component: () => import('../components/pages/calendar/Calendar.vue'),
  },
  /// --- Patients --- ///
  {
    path: '/patients', name: 'Patients',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['patients'] },
    component: () => import('../components/pages/patients/Patients.vue'),
  },
  {
    path: '/logs', name: 'Logs',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['log_history'] },
    component: () => import('../components/pages/logs/Logs.vue'),
  },
  {
    path: '/waiting', name: 'WaitingList',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['waiting_list'] },
    component: () => import('../components/pages/patients/WaitingList.vue'),
  },
  {
    path: '/billing', name: 'Billing',
    meta: { middleware: [authorized], layout: "default", rights: ['billing'] },
    // component:() => import('../components/pages/insurance/Insurance.vue'),
    component: () => import('../components/pages/billing/Billing.vue'),
  },
  {
    path: '/billing/obank/:payId/:qr', name: 'BillingOBankQR',
    meta: { middleware: [authorized], layout: "default" },
    component:() => import('../components/pages/billing/BillingOBankQr.vue'),
  },
  {
    path: '/sessions', name: 'Sessions',
    meta: { middleware: [authorized], layout: "default" },
    // component:() => import('../components/pages/insurance/Insurance.vue'),
    component: () => import('../components/pages/auth/Sessions.vue'),
  },
  {
    path: '/unpaid', name: 'Unpaid',
    meta: { middleware: [authorized], layout: "default" },
    // component:() => import('../components/pages/insurance/Insurance.vue'),
    component: () => import('../components/pages/billing/Unpaid.vue'),
  },
  {
    path: '/expenses', name: 'Expenses',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['enter_expenses'] },
    component: () => import('../components/pages/expenses/Expenses.vue'),
  },
  {
    path: '/income', name: 'Income',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['enter_income'] },
    component: () => import('../components/pages/income/Income.vue'),
  },
  {
    path: '/market', name: 'MarketPage',
    meta: { middleware: [authorized, paid], layout: "default", countries: ['RU'] },
    component:() => import('../components/pages/market/MarketApps.vue'),
  },
  {
    path: '/market/:id', name: 'MarketAppPage',
    meta: { middleware: [authorized, paid], layout: "default", countries: ['RU'] },
    component:() => import('../components/pages/market/MarketAppPage.vue'),
  },
  {
    path: '/gift', name: 'GiftPage',
    meta: { middleware: [authorized, paid], layout: "default" },
    component: () => import('../components/pages/marketing/GiftPage.vue'),
  },
  {
    path: '/gift/form', name: 'GiftForm',
    meta: { layout: "empty" },
    // component:() => import('../components/pages/auth/Login.vue'),
    component: () => import('../components/pages/marketing/GiftForm.vue'),
  },
  {
    path: '/payment/back', name: 'PaymentBack',
    meta: { middleware: [authorized], layout: "default" },
    // component:() => import('../components/pages/logs/Logs.vue'),
    component: () => import('../components/pages/settings/PaymentBack.vue'),
  },
  {
    path: '/diagnocat', name: 'ClinicDiagnocatStudies',
    meta: { middleware: [authorized], layout: "default", rights: ['diagnocat'], countries: ['RU'] },
    component:() => import('../components/pages/diagnocat/ClinicDiagnoCatStudies.vue'),
    // component: PaymentBack,
  },
  {
    path: '/maintenance', name: "SettingsMaintenance",
    meta: { layout: "empty" },
    component: () => import('../components/pages/settings/SettingsMaintenance.vue')
  },
  {
    path: '/test', name: "SettingsTest",
    meta: { layout: "empty" },
    component: () => import('../components/pages/settings/SettingsTest.vue')
  },
  patient,
  warehouses,
  services,
  staff,
  reports,
  accounting,
  templates,
  cashdesk,
  cashregister,
  settings,
  planning,
  crm,
  egisz,
  marketing,
  insurance,
  ...plan_treatments,
  laboratories,
  visits,
  superadmin,
  {
    path: '/:path', name: '404',
    meta: { layout: "empty" },
    component: () => import('../components/pages/general/404.vue')
  },
]


const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
    return { x: 0, y: 0 }
  }
})


///--- *** MIDDLEWARE *** ---///

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) return context.next
  return () => {
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  };
}

router.beforeEach((to, from, next) => {
  if(![
    'PatientVisits', 'PatientFormula', 'PatientPayments', 'PatientComments',
    'PatientPersonal', 'CRMSalesFunnelApplications', 'PatientNotifications',
    'PatientTasks', 'PatientDocuments', 'PatientNotes', 'PatientScans',
    'PatientInsurancePolises', 'PatientDepositTransactions', 'PatientFamilyAccount',
    'PatientTreatmentPlan', 'PatientLeads', 'PatientCanban', 'PatientNDFLs',
    'PatientLaboratoryOrders', 'PatientDiagnoCatStudies'
  ].includes(to.name)) {
    store.commit('setFunnelApplicationsCache', null)
  }
  if(from.name && to.name === 'PatientVisitPage' && from.name !== 'PatientVisitPage') {
    store.commit('setBackLink', from)
  }
  if(window && window.innerWidth <= 768) {
    store.commit('setSidebarCollapsed', true)
  }
  /// ** check for page update
  const now = Date.now()
  const minutesUpdateInterval = 720
  let lastUpdate = window.localStorage.getItem('lastUpdate') ?? 0
  const diff = (now - lastUpdate) / 1000
  if(diff > (60 * minutesUpdateInterval) || JwtService.shouldReload()) {
    window.localStorage.setItem('lastUpdate', now)
    JwtService.turnOffReload()
    window.location.href = to.fullPath
  }
  /// *** end of check for page update
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]
    const context = { from, next, router, to }
    const nextMiddleware = nextFactory(context, middleware, 1)
    return middleware[0]({ ...context, next: nextMiddleware })
  }

  return next()
})

// a page file of the previous build after a deploy: reload to get the new one (see reloadOnChunkError)
router.onError((error, to) => reloadOnChunkError(error, to?.fullPath || window.location.href))

export default router
